import { ThunkAction } from "redux-thunk";
import StoreState from "../../../redux/interfaces/StoreState";
import { Dispatch } from "redux";
import { OktaToken } from "../../../lib/Authentication/interfaces/OktaAuth";
import * as AuthenticationService from '../../../lib/Authentication/AuthenticationService';
import * as AppCreators from '../../../redux/creators/AppCreators';

export function onCheckAuthentication(): ThunkAction<void, StoreState, void, any> {
  return async (dispatch: Dispatch<any>, getState: () => StoreState) => {

    dispatch(AppCreators.SetAuthenticationLoading(true));

    const authenticationToken: OktaToken | null = await AuthenticationService.CheckAuthentication();

    dispatch(AppCreators.SetAuthenticationToken(authenticationToken));

    dispatch(AppCreators.SetAuthenticationLoading(false));

  }
}

export function onLogout(): ThunkAction<void, StoreState, void, any> {
  return async (dispatch: Dispatch<any>, getState: () => StoreState) => {
    // Logout clears tokenManager and localStorage/sessionStorage first, then signOut (may redirect).
    await AuthenticationService.Logout();

    // Clear Redux so next load never sees stale token; then redirect to login.
    dispatch(AppCreators.SetAuthenticationToken(null));
    window.location.href = '/';
  }
}